import { REACT_APP_VMS_BASE_URL } from "../utils/urls";

const fetchAllContacts = async () => {
  const result = await fetch(`${REACT_APP_VMS_BASE_URL}/contacts`);
  const contacts = await result.json();
  return contacts;
};

export default fetchAllContacts;
